

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Customers from './components/Customers';
import Deliveries from './components/Deliveries';
import Payments from './components/Payments';
import AdminManagement from './components/AdminManagement';
import Reminders from './components/Reminders'; // ✅ Import Reminders
import { Toaster } from 'react-hot-toast';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(localStorage.getItem('token'));
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem('token');
      if (currentToken !== token) {
        setToken(currentToken);
      }
    }, 500);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [token]);

  console.log('App.js - Token:', token ? '✅ Present' : '❌ Missing');

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={token ? <Dashboard /> : <Navigate to="/login" replace />} 
          />
          <Route 
            path="/customers" 
            element={token ? <Customers /> : <Navigate to="/login" replace />} 
          />
          <Route 
            path="/deliveries" 
            element={token ? <Deliveries /> : <Navigate to="/login" replace />} 
          />
          <Route 
            path="/payments" 
            element={token ? <Payments /> : <Navigate to="/login" replace />} 
          />
          <Route 
            path="/reminders"  // ✅ New Reminders Route
            element={token ? <Reminders /> : <Navigate to="/login" replace />} 
          />
          <Route 
            path="/admins" 
            element={token ? <AdminManagement /> : <Navigate to="/login" replace />} 
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;